import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Header, Message, Icon } from "semantic-ui-react";
import { NavLink, useNavigate } from "react-router-dom";
import PastExams from "../components/Bookings/PastExams";
import ScheduledExams from "../components/Bookings/ScheduledExams";
import { withTranslation } from "react-i18next";

class StudentDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasProfileImage: false,
      imageCheckComplete: false,
    };
  }

  componentDidMount() {
    this.checkProfileImageAndInstitution();
  }

  checkProfileImageAndInstitution = () => {
    if (!this.props.kc.tokenParsed.learning_institution) {
      this.props.navigate("/account-details");
      return;
    }
    const imageUrl = 
      `${process.env.REACT_APP_API_ADDRESS}/api/images/profile/` +
      `${this.props.kc.tokenParsed.sub}_user_profile_img.png?token=${
        this.props.kc.token
      }&cb=${Math.round(new Date().getTime() / 1000)}`;

    const img = new Image();
    
    img.addEventListener("load", () => {
      this.setState({ hasProfileImage: true, imageCheckComplete: true });
    });
    
    img.addEventListener("error", () => {
      this.setState({ hasProfileImage: false, imageCheckComplete: true }, () => {
        // Redirect to account details page if no profile image
        this.props.navigate("/account-details");
      });
    });
    
    img.src = imageUrl;
  };

  render() {
    return (
      <Container style={{ marginTop: "3em" }}>
        <Header as="h3" style={{ margin: "0 0 1.5em 0", fontWeight: "400", color: "#666" }}>
          {this.props.t("general.myDashboard")}
        </Header>
        <ScheduledExams />
        <PastExams />
      </Container>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      kc: state.keycloak,
    }),
    {}
  )((props) => {
    const navigate = useNavigate();
    return <StudentDashboard {...props} navigate={navigate} />;
  })
);
